const endpoints = {
	createContractSectionCategory: '/contracts/config/createContractSectionCategory',
	updateContractSectionCategory: '/contracts/config/updateContractSectionCategory',
	updateContractSectionCategoryOrders: '/contracts/config/updateContractSectionCategoryOrders',
	getCompanyContractSectionCategories: '/contracts/config/getCompanyContractSectionCategories',
	deleteContractSectionCategory: '/contracts/config/deleteContractSectionCategory',
	createContractSection: '/contracts/config/createContractSection',
	updateContractSection: '/contracts/config/updateContractSection',
	updateContractSectionOrders: '/contracts/config/updateContractSectionOrders',
	deleteContractSection: '/contracts/config/deleteContractSection',
	getCompanyContractSections: '/contracts/config/getCompanyContractSections',
	createContractTitle: '/contracts/config/createContractTitle',
	updateContractTitle: '/contracts/config/updateContractTitle',
	updateOrderTitleContract: '/contracts/config/updateOrderTitle',
	getContractTitles: '/contracts/config/getContractTitles',
	deleteContractTitle: '/contracts/config/deleteContractTitle',
	createContractSubtitle: '/contracts/config/createContractSubtitle',
	updateContractSubtitle: '/contracts/config/updateContractSubtitle',
	updateOrderSubtitleContract: '/contracts/config/updateOrderSubtitle',
	getContractSubtitles: '/contracts/config/getContractSubtitles',
	deleteContractSubtitle: '/contracts/config/deleteContractSubtitle',
	createContract: '/contracts/createContract',
	createContractorContract: '/contracts/createContractorContract',
	checkClosedSubcontracts: '/contracts/checkClosedSubcontracts',
	updateContract: '/contracts/updateContract',
	createContractSectionProject: '/contracts/createContractSection',
	createContractSectionContent: '/contracts/createContractSectionContent',
	getContract: '/contracts/getContract',
	getCompanyContracts: '/contracts/getCompanyContracts',
	getCompanySubcontractorContracts: '/contracts/getCompanySubcontractorContracts',
	updateContractSectionProject: '/contracts/updateContractSection',
	updateContractSectionContent: '/contracts/updateContractSectionContent',
	updateContractSectionProjectOrders: '/contracts/updateContractSectionOrders',
	updateContractSectionContentOrders: '/contracts/updateContractSectionContentOrders',
	deleteContractSectionProject: '/contracts/deleteContractSection',
	deleteContractSectionContent: '/contracts/deleteContractSectionContent',
	createContractTemplate: '/contracts/createContractTemplate',
	setTemplateToContract: '/contracts/setTemplateToContract',
	getContractTemplates: '/contracts/getContractTemplates',
	deleteContractTemplate: '/contracts/deleteContractTemplate',
	createContractContentComment: '/contracts/createContractContentComment',
	updateContractContentComment: '/contracts/updateContractContentComment',
	deleteContractContentComment: '/contracts/deleteContractContentComment',
	createContractPDF: '/contracts/createContractPDF',
	createContractPdfFromPreview: '/contracts/createContractPdfFromPreview',
	sendContractPdfEmail: '/contracts/sendContractPdfEmail',
	addNewStatus: '/contracts/addNewStatus',
	signContract: '/contracts/signContract',
	companySignContract: '/contracts/companySignContract',
	sendContractPaymentRequest: '/contracts/sendContractPaymentRequest',
	addContractAddendum: '/contracts/addContractAddendum',
	deleteContractAddendum: '/contracts/deleteContractAddendum',
	anulateSubcontract: '/contracts/anulateSubcontract',
	contractStatusRequest: '/contracts/contractStatusRequest',
	resolveContractStatusRequest: '/contracts/resolveContractStatusRequest',
	getSubcontractProjectHistory: '/contracts/getSubcontractProjectHistory',
}
export {endpoints}